<template>
  <el-card shadow="never" class="we-explain-card">
    <div slot="header" class="we-explain-head">
      <div class="we-card-title">
        <i class="el-icon-document"></i>
        <span>作业说明</span>
      </div>
      <el-button type="text" class="we-clear-btn" @click="onClear">
        <i class="el-icon-delete"></i> 清空
      </el-button>
    </div>
    <tinymce :id="editorId" v-model="innerValue" :height="300" />
  </el-card>
</template>

<script>
  export default {
    name: 'WorkEditorExplain',
    props: {
      value: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        editorId: `work-explain-${Date.now()}`,
        innerValue: this.value || ''
      }
    },
    watch: {
      value(val) {
        if (val !== this.innerValue) {
          this.innerValue = val || ''
        }
      },
      innerValue(val) {
        this.$emit('input', val)
      }
    },
    methods: {
      onClear() {
        this.$confirm('确定要清空作业说明吗？', '提示', {
          type: 'warning'
        })
          .then(() => {
            this.innerValue = ''
            this.$message.success('已清空作业说明')
          })
          .catch(() => { })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .we-explain-card {
    border-radius: 10px;
    border: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

    ::v-deep .el-card__header {
      padding: 14px 20px;
    }

    ::v-deep .el-card__body {
      padding: 12px 20px 20px;
    }
  }

  .we-explain-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .we-card-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 600;
    color: #1d2129;

    i {
      color: #4f6ef7;
    }
  }

  .we-clear-btn {
    color: #86909c;

    &:hover {
      color: #f7607d;
    }
  }
</style>
